import React from "react";
import styled, { css } from "styled-components";
import Modal from "../../../Modal";
import { rem } from "polished";
import Button, { ButtonWrapper } from "../../../Button";
import ListItem from "../ListItem";
import { useDispatch, useSelector } from "react-redux";
import {
  addHole,
  getHoles,
  removeHole,
  updateHoleDimension,
  updateHoleGap,
  updateHolePos,
} from "../../../../lib/redux/slices/holes-slice";
import config from "../../../../utils/config";
import { getCanvasValues, wrtRatio } from "../../../../utils/canvas";
import {
  changeCurrentEvent,
  getDimensions,
  getLineAlignment,
  getTileShape,
} from "../../../../lib/redux/slices/dimensions-slice";
import {
  addMeasurement,
  removeMeasurement,
} from "../../../../lib/redux/slices/measurements-slice";
import { getMeasurement } from "../../../Builder/SinkGroup/measurement-utils";
import { nanoid } from "nanoid";
import ItemDetailModal from "../ItemDetailModal";
import { useUpdateCart } from "../../../../hooks/use-update-cart";

const Holes = ({ data, stage }) => {
  const [open, onSetModal] = React.useState(false);

  const holes = useSelector(getHoles);
  const currentShape = useSelector(getTileShape);
  const dimensions = useSelector(getDimensions);
  const lineAlignment = useSelector(getLineAlignment);
  const dispatch = useDispatch();
  const [selectedItem, setSelectedItem] = React.useState([]);
  const [openDetailModal, onSetDetailModal] = React.useState(false);
  const { updateCart } = useUpdateCart();

  const removeSelected = (selectedIndex, uniqId) => {
    const remainingHoles = holes.filter((_, index) => index !== selectedIndex);
    dispatch(removeHole(remainingHoles));
    updateCart((storeData) => ({
      ...storeData,
      holes: remainingHoles,
    }));
    dispatch(removeMeasurement({ index: uniqId, type: "holes" }));
  };

  const attachHole = (attachedHole) => {
    const uniqID = nanoid();
    setSelectedItem(attachedHole);

    // const image = new Image();
    // image.src = attachedHole.image;
    // image.onload = () => {
    const Imagewidth = attachedHole.breadth || 250;
    const Imageheight = attachedHole.length || 250;

    const width =
      attachedHole.type === "circle" ? attachedHole.radius : Imagewidth;
    // : attachedHole.imageWidth;
    const height =
      attachedHole.type === "circle" ? attachedHole.radius : Imageheight;
    // : attachedHole.imageHeight;

    dispatch(
      addHole({
        ...attachedHole,
        holeGap: config.defaultTileGap,
        width: width,
        height: height,
        uniqId: uniqID,
      })
    );

    updateCart((storeData) => ({
      ...storeData,
      holes: [
        ...storeData.holes,
        {
          ...attachedHole,
          holeGap: config.defaultTileGap,
          width: width,
          height: height,
          uniqId: uniqID,
        },
      ],
    }));

    const { canvasLeft, canvasRight, canvasBottom, canvasTop } =
      getCanvasValues(dimensions, currentShape, lineAlignment);
    const upcomingGroupID = `element-holes-${uniqID}`;

    setTimeout(() => {
      const element = stage.current.findOne(`#${upcomingGroupID}`);

      dispatch(
        addMeasurement(
          getMeasurement({
            element,
            groupWidth: element.width(),
            groupHeight: element.height(),
            currentShape,
            canvasLeft,
            canvasRight,
            canvasBottom,
            canvasTop,
          })
        )
      );
    }, 10);
    // };
  };

  return (
    <Layout>
      {holes.length ? (
        <HolesList
          data={holes}
          removeSelected={removeSelected}
          stage={stage}
          openDetailModal={openDetailModal}
          onSetDetailModal={onSetDetailModal}
          setSelectedItem={setSelectedItem}
        />
      ) : null}
      <ButtonWrapper>
        <Button onClick={() => onSetModal(!open)}>VÄLJ</Button>
      </ButtonWrapper>
      <Modal
        wrapperId="modal"
        isOpen={open}
        overlayClick
        handleClose={() => onSetModal(false)}
        styles={{
          maxWidth: "90%",
          maxHeight: "90%",
          height: "100%",
          width: "100%",
          borderRadius: 0,
        }}
        parentStyles={{
          zIndex: 9999,
        }}
        title={data.label}
      >
        {data && (
          <ListItem
            data={data.options}
            onHandleSet={attachHole}
            onModalClose={() => onSetModal(false)}
            setSelectedItem={setSelectedItem}
            onSetDetailModal={onSetDetailModal}
          />
        )}
      </Modal>
      <ItemDetailModal
        selectedItem={selectedItem}
        openDetailModal={openDetailModal}
        onSetDetailModal={onSetDetailModal}
      />
    </Layout>
  );
};
export default Holes;

const HolesList = ({
  data,
  removeSelected,
  stage,
  openDetailModal,
  onSetDetailModal,
  setSelectedItem,
}) => {
  const dispatch = useDispatch();
  const currentShape = useSelector(getTileShape);
  const dimensions = useSelector(getDimensions);
  const lineAlignment = useSelector(getLineAlignment);

  const { canvasLeft, canvasRight, canvasTop, canvasBottom } = getCanvasValues(
    dimensions,
    currentShape,
    lineAlignment
  );

  const isLeft = currentShape === "left";
  const isRight = currentShape === "right";
  const isSimple = currentShape === "simple";

  const onChangeHoleGap = (value, index) =>
    dispatch(updateHoleGap({ value, index }));

  const onChangeCoordinate = (value, item, index, itemUniqueID) => {
    const { x, y, rotation, offsetX, offsetY } = item;

    const upcomingGroupID = `element-holes-${itemUniqueID}`;
    const element = stage.current.findOne(`#${upcomingGroupID}`);

    dispatch(
      updateHolePos({
        index: index,
        x: [0, 180].includes(rotation) ? Math.round(value) : x,
        y: ![0, 180].includes(rotation) ? Math.round(value) : y,
        rotation: rotation,
        offsetX: offsetX,
        offsetY: offsetY,
      })
    );

    dispatch(
      addMeasurement(
        getMeasurement({
          element,
          groupWidth: item.width,
          groupHeight: item.height,
          currentShape,
          canvasLeft,
          canvasRight,
          tileGap: item.holeGap,
        })
      )
    );

    dispatch(changeCurrentEvent("input"));
  };

  const onChangeHoleDimension = (width, height, index) =>
    dispatch(updateHoleDimension({ width, height, index }));
  return (
    <HolesListLayout>
      {data.map((item, index) => {
        const { x, y, rotation, width, holeGap, offsetX, offsetY } = item;

        const tileGap = parseInt(holeGap);

        const imageRatio = config.imageRatio;
        const value = [0, 180].includes(rotation) ? x : y;
        let min = (width / config.defaultRatio) * imageRatio + tileGap / imageRatio + 7;
        let max = 0;

        if (isSimple) {
          max = [0, 180].includes(rotation)
            ? wrtRatio(canvasTop, "*") - min
            : wrtRatio(canvasLeft, "*") - min;
        }

        if (isLeft) {
          if ([0, 180].includes(rotation)) {
            max = wrtRatio(canvasTop, "*") - min;
          }
          if ([90, -90].includes(rotation)) {
            max = wrtRatio(canvasLeft, "*") - min;
          }
          if ([270].includes(rotation)) {
            max = wrtRatio(canvasRight, "*") - min;
          }

          if (
            wrtRatio(x, "/") <
              canvasBottom - offsetX + wrtRatio(tileGap, "/") &&
            wrtRatio(y, "/") >=
              canvasRight - offsetY - wrtRatio(tileGap, "/") &&
            [0].includes(rotation)
          ) {
            max = wrtRatio(canvasBottom, "*") - min;
          }
        }

        if (isRight) {
          if ([0, 180].includes(rotation)) {
            max = wrtRatio(canvasTop, "*") - min;
          }
          if ([-90, 90].includes(rotation)) {
            max = wrtRatio(canvasLeft, "*") - min;
          }
          if ([270].includes(rotation)) {
            max = wrtRatio(canvasRight, "*") - min;
          }
          if (
            wrtRatio(x, "/") > canvasBottom &&
            wrtRatio(y, "/") > canvasLeft - offsetY - wrtRatio(tileGap - 7, "/")
          ) {
            if ([0].includes(rotation)) {
              min =
                canvasBottom * config.defaultRatio +
                (width / config.defaultRatio) * imageRatio +
                tileGap / imageRatio +
                7;
              max =
                wrtRatio(canvasTop, "*") -
                ((width / config.defaultRatio) * imageRatio + tileGap / imageRatio + 7);
            } else {
              max = wrtRatio(canvasRight, "*") - min;
            }
          }
        }
        return (
          <div className="item" key={index}>
            <div className="item-details">
              <div
                className="item-header"
                onClick={() => {
                  setSelectedItem(item);
                  onSetDetailModal(!openDetailModal);
                }}
              >
                <img
                  src={item.image}
                  alt={item.label}
                  width={item.type === "circle" ? 20 : 60}
                />
                <div className="title">{item.label}</div>
              </div>
              <div className="remove">
                <div
                  className="close"
                  onClick={() => removeSelected(index, item.uniqId)}
                >
                  X
                </div>
              </div>
            </div>
            <div className="dimension">
              <label>
                <span>Sida</span>
                {/* <input
                  type="number"
                  step={1}
                  value={Math.round(value)}
                  onChange={(e) =>
                    onChangeCoordinate(e.target.value, item, i, item.uniqId)
                  }
                /> */}
                <InputField
                  {...{
                    min,
                    max,
                    value,
                    item,
                    index,
                    onChangeCoordinate,
                  }}
                />
              </label>
              <label>
                <span>Fram</span>
                <input
                  type="number"
                  min={parseInt(item.min_fram)}
                  max={parseInt(item.max_fram)}
                  value={parseInt(item.holeGap)}
                  onChange={(e) => onChangeHoleGap(e.target.value, index)}
                />
              </label>
              {item.type === "circle" && item.enable_diameter ? (
                <label>
                  <span>Diameter</span>
                  <input
                    type="number"
                    min={parseInt(item.min_radius)}
                    max={parseInt(item.max_radius)}
                    value={parseInt(item.width)}
                    onChange={(e) =>
                      onChangeHoleDimension(
                        e.target.value,
                        e.target.value,
                        index
                      )
                    }
                  />
                </label>
              ) : null}
              {item.type === "square" && item.enable_width_height ? (
                <>
                  <label>
                    <span>Bredd</span>
                    <input
                      min={parseInt(item.min_breadth)}
                      max={parseInt(item.max_breadth)}
                      type="number"
                      value={parseInt(item.width)}
                      onChange={(e) =>
                        onChangeHoleDimension(
                          e.target.value,
                          item.height,
                          index
                        )
                      }
                    />
                  </label>
                  <label>
                    <span>Höjd</span>
                    <input
                      min={parseInt(item.min_length)}
                      max={parseInt(item.max_length)}
                      type="number"
                      value={parseInt(item.height)}
                      onChange={(e) =>
                        onChangeHoleDimension(item.width, e.target.value, index)
                      }
                    />
                  </label>
                </>
              ) : null}
            </div>
          </div>
        );
      })}
    </HolesListLayout>
  );
};

const InputField = ({ min, max, value, item, index, onChangeCoordinate }) => {
  const [inputValue, setInputValue] = React.useState(0);

  React.useEffect(() => {
    setInputValue(Math.round(value));
  }, [value]);

  const verifyLimit = (e) => {
    const value = Math.round(e.target.value) || 0;

    const limitValue = (min, max, val) => Math.min(Math.max(min, val), max);

    const limit = (minValue, maxValue) => {
      const limitedValue = limitValue(minValue, maxValue, value);
      setInputValue(Math.round(limitedValue));
      return Math.round(limitedValue);
    };

    onChangeCoordinate(limit(min, max), item, index, item.uniqId);
  };

  const handleChange = (e) => {
    let value = Math.round(e.target.value);
    setInputValue(value);
  };

  return (
    <input
      type="number"
      step={1}
      min={Math.round(min)}
      max={Math.round(max)}
      value={inputValue}
      onBlur={(e) => verifyLimit(e)}
      onChange={(e) => handleChange(e)}
    />
  );
};

const HolesListLayout = styled.div`
  ${({ theme }) => css`
    .item {
      margin-top: ${rem(20)};

      + .item {
        border-top: 1px solid ${theme.colors.gray[400]};
        margin-top: ${rem(40)};
        padding-top: ${rem(20)};
      }

      .item-details {
        display: flex;
        flex-direction: row;
        align-items: center;

        .item-header {
          flex-grow: 1;
          display: flex;
          flex-direction: row;
          align-items: center;

          .title {
            margin-left: ${rem(15)};
          }
        }
      }

      .dimension {
        margin-top: ${rem(30)};

        label {
          display: flex;
          align-items: center;
          justify-content: center;

          + label {
            margin-top: ${rem(15)};
          }

          span {
            flex: 0 0 80px;
            max-width: 80px;
          }

          input {
            width: 100%;
            border: 1px solid ${theme.colors.gray[400]};
            min-height: 30px;
            padding: 0 5px;
          }
        }
      }

      .remove {
        flex: 0 0 15px;
        max-width: 15px;
        text-align: center;
        cursor: pointer;
      }
    }
  `}
`;
const Layout = styled.div``;
